<script>
  import ImportantLink from '../ImportantLink.svelte';
  import Link from '../Link.svelte';

  export let importantLinks;
  export let links;
  export let lang = undefined;
</script>

<div class='links-box'>
  {#if importantLinks.length > 0}
    <div class='links-box-important-links'>
      {#each importantLinks as importantLink}
        <ImportantLink value={importantLink} bind:lang/>
      {/each}
    </div>
  {/if}

  {#if links.length > 0}
    <div class='links-box-links'>
      {#each links as link}
        <Link value={link} bind:lang/>
      {/each}
    </div>
  {/if}
</div>

<style>
  .links-box {
    display: flex;
    flex-direction: column;
    gap: 20px;

    padding: 20px;

    border-radius: var(--radius-lg);

    background: var(--grey-1);
  }

  .links-box-important-links {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .links-box-links {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  :global(body.dark) .links-box {
    background: var(--grey-8);
  }
</style>
